const validateId = (str) => {
  const regex = /^([0-9]*)_([0-9]*)$/;

  return regex.test(str);
};

export default validateId;
